import { BetAreaPanel } from './BetArea';
export const TeenPattiBetAreaPanel = () => {
    return <BetAreaPanel />;
};
